import React from "react";
import SectionCard from "../../ui/SectionCard";
import { vaginalBleedingFlowOptions } from "../../../config/symptomsConfig";

interface FlowSectionCardProps {
  value: string | null;
  onChange: (value: string) => void;
  isNoBleeding: boolean;
  disabled?: boolean;
}

export default function FlowSectionCard({
  value,
  onChange,
  isNoBleeding,
  disabled = false,
}: FlowSectionCardProps) {
  return (
    <SectionCard
      title="Flow"
      description="Generally, flow reduces over time in postpartum and an increase may imply period. How would you describe your flow today?"
    >
      <div className="flex flex-col gap-3">
        {vaginalBleedingFlowOptions.map((opt) => {
          const active = value === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              disabled={disabled}
              onClick={() => onChange(opt.value)}
              className={[
                "w-full py-3 px-4 rounded-lg text-sm font-normal transition text-center",
                active
                  ? "bg-[#1e5e5b] text-white border-2 border-[#1e5e5b]"
                  : "bg-white text-black border border-black/10 hover:border-black/20",
                "disabled:opacity-50 disabled:cursor-not-allowed",
              ].join(" ")}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
      {isNoBleeding && (
        <p className="mt-3 text-sm text-[#4b5563]">
          Noted — no bleeding today.
        </p>
      )}
    </SectionCard>
  );
}
